import ReactGA from 'react-ga'

export const initGA = () => {
  //console.log('GA Init')
  //ReactGA.initialize('UA-123966309-1')
  // real GA
  ReactGA.initialize('UA-115287290-3')
}

export const logPageView = page => {
  // console.log('Logging pageview for ${window.location.pathname}')
  ReactGA.set({ page: window.location.pathname })
  ReactGA.pageview(window.location.pathname)
}

export const gaEvent = (cat, act, lab, val, nonInter, tran) => {
  // console.log('GA Send Event'+cat+' '+act)
  ReactGA.event({
    category: cat,
    action: act,
    label: lab,
    value: val,
    nonInteraction: nonInter,
    transport: tran
  })
}



// WEBPACK FOOTER //
// ./src/ga/analytics.js